import { Container, dispatcher, IEvent, ingenuity, SpineBase } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior, View } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstants } from "@quest/slot-core";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class BaseGameViewGame extends View {
  private multiplerAnim: SpineBase;
  private collectAllAnim: SpineBase;
  private bigPrizeAnim: SpineBase;
  private multiplerHitAnim: SpineBase;
  private collectAllHitAnim: SpineBase;
  private bigPrizeHitAnim: SpineBase;

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SET_WIN_VALUE, this.setTickupWinValue, this);
    dispatcher.on(eventDispatchers.PLAY_WIN_ANIM_LEFT_CHARACTER, this.playWinAnimation, this);
    dispatcher.on(eventDispatchers.PLAY_HIT_ANIMATION, this.playHitAnimation, this);
  }

  protected initializeComponents(): void {
    super.initializeComponents();
    this.multiplerAnim = this.getSpineById("multiplierRed");
    this.collectAllAnim = this.getSpineById("collectAllGreen");
    this.bigPrizeAnim = this.getSpineById("BigPrizeBlue");
    this.multiplerHitAnim = this.getSpineById("MultiplerRedEffects");
    this.collectAllHitAnim = this.getSpineById("collectAllGreenEffects");
    this.bigPrizeHitAnim = this.getSpineById("BigPrizeBlueEffects");
  }

  /**
   * overrided to avoid symbol fade as per game
   */
  protected showAlpha(): void {
    //
  }

  private checkIfLevelUp(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getRedElementCount() - 1 < 3 ||
      (ingenuity.parserModel as GameParserModel).getRedElementCount() - 1 < 5
    ) {
      this.multiplerHitAnim.playAnim("Red_element_level_up_glow_effect");
    }
    if (
      (ingenuity.parserModel as GameParserModel).getBlueElementCount() - 1 < 3 ||
      (ingenuity.parserModel as GameParserModel).getBlueElementCount() - 1 < 5
    ) {
      this.multiplerHitAnim.playAnim("Blue_element_level_up_glow_effect");
    }
    if (
      (ingenuity.parserModel as GameParserModel).getGreenElementCount() - 1 < 3 ||
      (ingenuity.parserModel as GameParserModel).getGreenElementCount() - 1 < 5
    ) {
      this.multiplerHitAnim.playAnim("Green_element_level_up_glow_effect");
    }
    this.playLeftCharacterSpine();
  }

  /**
   * method to play left character idle spine as per stage
   */
  private playLeftCharacterSpine() {
    let redStage = (ingenuity.parserModel as GameParserModel).getRedStage();
    let greenStage = (ingenuity.parserModel as GameParserModel).getGreenStage();
    let BlueStage = (ingenuity.parserModel as GameParserModel).getBlueStage();
    this.multiplerAnim.playAnim(`stage_${redStage}_idle`, true);
    this.collectAllAnim.playAnim(`stage_${greenStage}_idle`, true);
    this.bigPrizeAnim.playAnim(`stage_${BlueStage}_idle`, true);
  }
  /**
   * play hit anim when trail hits the character
   * @param data charater id
   */
  private playHitAnimation(data: IEvent): void {
    switch (data.data) {
      case gameConstants.CHARACTER_MULTIPLIER:
        this.multiplerHitAnim.visible = true;
        this.multiplerHitAnim.playAnim("Red_element_glow_effect");
        this.multiplerHitAnim.onComplete.addOnce(() => {
          this.multiplerHitAnim.visible = false;
        });
        break;
      case gameConstants.CHARACTER_BIG_PRIZE:
        this.bigPrizeHitAnim.visible = true;
        this.bigPrizeHitAnim.playAnim("Blue_element_glow_effect");
        this.bigPrizeHitAnim.onComplete.addOnce(() => {
          this.bigPrizeHitAnim.visible = false;
        });
        break;
      case gameConstants.CHARACTER_COLLECT_ALL:
        this.collectAllHitAnim.visible = true;
        this.collectAllHitAnim.playAnim("Green_element_glow_effect");
        this.collectAllHitAnim.onComplete.addOnce(() => {
          this.collectAllHitAnim.visible = false;
        });
        break;
    }
    this.checkIfLevelUp();
  }

  /**
   * play win animation if hold 'n' respin triggered
   */
  private playWinAnimation() {
    if (
      (ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus() &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState
    ) {
      let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
      let redStage = (ingenuity.parserModel as GameParserModel).getRedStage();
      let greenStage = (ingenuity.parserModel as GameParserModel).getGreenStage();
      let BlueStage = (ingenuity.parserModel as GameParserModel).getBlueStage();
      if (triggerType.includes(gameConstants.SKULL_BIG_PRIZE)) {
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.BLUE_CHARACTER_WIN_SOUND,
          1,
          false,
          SlotConstantsBehavior.SOUND_LIST_POSTLOAD
        );
        this.bigPrizeAnim.playAnim(`stage_${BlueStage}_win`, true);
      }
      if (triggerType.includes(gameConstants.SKULL_MULTIPLIER)) {
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.RED_CHARACTER_WIN_SOUND,
          1,
          false,
          SlotConstantsBehavior.SOUND_LIST_POSTLOAD
        );
        this.multiplerAnim.playAnim(`stage_${redStage}_win`, true);
      }
      if (triggerType.includes(gameConstants.SKULL_COLLECT_ALL)) {
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.GREEN_CHARACTER_WIN_SOUND,
          1,
          false,
          SlotConstantsBehavior.SOUND_LIST_POSTLOAD
        );
        this.collectAllAnim.playAnim(`stage_${greenStage}_win`, true);
      }
    }
  }

  show(): void {
    super.show();
    this.playLeftCharacterSpine();
  }

  /**
   * function is over rided to play spine animation for anticipation
   * the animation name is changed in given spine
   */
  showAnticipation(reel: number, callback?: () => void, callbackScope?: any): void {
    if (typeof this.anticipationContainer === "undefined") {
      this.anticipationContainer = new Container(this.json, this.game);
      this.anticipationContainer.name = SlotConstants.AnticipationConatiner;
      this.addChild(this.anticipationContainer);
    }
    if (this.json.anticipationAnim) {
      const anticJson = this.json.anticipationAnim;
      anticJson.id = "anticipation";
      anticJson.type = "spine";
      const anticipation = this.createSpine(anticJson);
      if (anticipation) {
        anticipation.visible = true;
        this.anticipationContainer.addChild(anticipation);
        this.anticipationContainer.x = this.json.reels.reels[reel].x + this.json.reels.x + this.json.anticipationAnim.valueX;
        this.anticipationContainer.y = this.json.reels.reels[reel].y + this.json.reels.y + this.json.anticipationAnim.valueY;
        this.addChild(this.anticipationContainer);
        anticipation.playAnim("in");
        anticipation.onComplete.addOnce(() => {
          anticipation.playAnim("loop", true);
        });
      }
    }
  }

  /**
   *
   * @param evt method to show tickup on win meter
   */
  protected setTickupWinValue(evt: IEvent): void {
    let value = evt.data.winValue;
    let duration = 0.6;
    let isValueInCredit = evt.data.creditValue;
    if (value === 0) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
    }
    if (isValueInCredit) {
      this.lblWinValue && this.lblWinValue.startTick(value, true, false, duration, true, () => {});
    } else {
      const converAmountToCoinFromCurrency = Math.round(Number(value) / ingenuity.configData.currentCoinValue).toString();
      this.lblWinValue && this.lblWinValue.setCoinFormattedValueToDecimal(converAmountToCoinFromCurrency, 0);
    }
  }

  // Override to play landing animation
  public landingAnimation(data: any) {
    const reelgrid = data[0];
    const reelview = data[1];
    const reelId = data[2];
    for (let i = 0; i < reelgrid[reelId].length; i++) {
      if (this.json.reels.symbolData[reelgrid[reelId][i]].hasLanding) {
        const symbol = reelview.getSymbolByPos(reelId, i);
        const staticSym = symbol.getStatic();
        const animSym: SpineBase = symbol.getAnimation() as SpineBase;
        if (animSym) {
          const staticSymParent = staticSym.parent;
          if (staticSymParent) {
            staticSym.visible = false;
            animSym.visible = true;
            staticSymParent.addChild(animSym);
            animSym.playAnim("static", false, 0);
            animSym.onComplete.addOnce(() => {
              animSym.playAnim("landing", false);
              const symId = reelgrid[reelId][i];
              this.playLandingSounds(symId);
              animSym.onComplete.addOnce(() => {
                if (
                  gameConstants.CHARACTER_MULTIPLIER === symId ||
                  gameConstants.CHARACTER_BIG_PRIZE === symId ||
                  gameConstants.CHARACTER_COLLECT_ALL === symId
                ) {
                  animSym.playAnim("idle", true);
                }
              }, this);
            }, this);
          }
        }
      }
    }
  }

  /**
   * play landing sound for symbol on reel
   * @param symId symbol id 
   */
  private playLandingSounds(symId: number): void {
    if (gameConstants.SYMBOL_WILD === symId) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.WILD_DROP_SOUND, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_DROP_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
    if (symId === gameConstants.CHARACTER_BIG_PRIZE) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.BLUE_ICON_DROP, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
    if (symId === gameConstants.CHARACTER_MULTIPLIER) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.RED_ICON_DROP, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
    if (symId === gameConstants.CHARACTER_COLLECT_ALL) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.GREEN_ICON_DROP, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
  }

  /**
   * overide to add win collection view on top
   */
  protected addButtonPanelOnTop(): void {
    super.addButtonPanelOnTop();
    dispatcher.fireEvent(eventDispatchers.ADD_LIGHTNING_VIEW_ON_TOP); //game event
  }
}
